import React, { Component } from 'react';
import { Alert } from '$common';
import CSSModules from 'react-css-modules';
import style from './layout.scss';
import Notification from './notification';
import PasswordModal from './password-modal';
import cx from 'classnames';

@CSSModules(style, { allowMultiple: true })
export default class Layout extends Component {
  render() {
    const {
      notification,
      children,
      onNotificationClose,
      loading,
      passwordRequired,
      onPasswordSubmit,
      alert
    } = this.props;

    const styleNames = cx({
      loading: loading,
      muhimma: process.muhimma.indexOf(process.target[0]) !== -1
    });

    return (
      <div className="full-height" styleName={styleNames}>
        {notification ? (
          <Notification
            notification={notification}
            onClose={onNotificationClose}
          />
        ) : null}

        {alert ? <Alert {...alert} /> : null}

        <PasswordModal
          isOpen={passwordRequired}
          onSubmit={onPasswordSubmit}
        />
        {children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/root/layout.js